import React, { useEffect, useState } from 'react';
import { ArrowRight, Zap, Landmark, Globe2, CreditCard, Bitcoin, Coins, Wallet as WalletIcon } from 'lucide-react';
import api from '../../services/api';
import { useNavigate } from 'react-router-dom';

const METHODS = [
  { Icon: Coins,     name: 'USDT TRC-20',      desc: 'Tether en red TRON. Sin fees de red, acreditación rápida.' },
  { Icon: Landmark,  name: 'Zelle',            desc: 'Solo para usuarios en EE.UU.' },
  { Icon: CreditCard, name: 'Mercado Pago',    desc: 'Argentina, México, Brasil.' },
  { Icon: Bitcoin,   name: 'Bitcoin on-chain', desc: 'Confirmación en ~10 minutos.' },
  { Icon: Zap,       name: 'Lightning Network', desc: 'Instantáneo, fee mínimo.' },
];

export default function Wallet() {
  const navigate = useNavigate();
  const openSendModal = () => navigate('/app/enviar');
  const [balance, setBalance] = useState(0);
  const [txs, setTxs] = useState([]);

  useEffect(() => {
    api.get('/api/v1/auth/me').then(r => setBalance(parseFloat(r.data?.balance_usd) || 0)).catch(() => {});
    api.get('/api/v1/transactions/').then(r => {
      const list = Array.isArray(r.data) ? r.data : [];
      setTxs(list.slice(0, 6));
    }).catch(() => {});
  }, []);

  return (
    <div style={{ maxWidth: 860, margin: '0 auto' }}>
      <h1 style={{ fontSize: 27, margin: '0 0 4px', letterSpacing: '-1px' }}>Pagos</h1>
      <p style={{ fontSize: 13, color: 'var(--muted)', margin: '0 0 18px' }}>
        En Guarapo no cargas saldo: pagas cada remesa en el momento, con el método que prefieras,
        y el dinero queda en escrow hasta que se confirma la entrega.
      </p>

      {balance > 0 && (
        <div className="g-card" style={{ display: 'flex', alignItems: 'center', gap: 14, padding: '16px 20px', marginBottom: 16, borderLeft: '4px solid #15803d' }}>
          <WalletIcon size={22} color="#15803d" />
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 11, fontWeight: 800, letterSpacing: '.07em', color: 'var(--faint)' }}>SALDO A FAVOR</div>
            <div style={{ fontSize: 22, fontWeight: 800 }}>${balance.toFixed(2)}</div>
            <div style={{ fontSize: 12, color: 'var(--muted)' }}>Crédito por reembolsos. Se aplica a tu próxima remesa; escríbenos a soporte para usarlo.</div>
          </div>
        </div>
      )}

      <div className="g-card" style={{ padding: '6px 20px', marginBottom: 16 }}>
        <div className="g-section-title" style={{ padding: '14px 0 0' }}>
          <h2>Métodos de pago</h2>
        </div>
        {METHODS.map(({ Icon, name, desc }, i) => (
          <div key={name} style={{
            display: 'flex', alignItems: 'center', gap: 14, padding: '14px 0',
            borderTop: i > 0 ? '1px solid #f1f1f4' : 'none',
          }}>
            <span style={{ width: 42, height: 42, borderRadius: 12, flexShrink: 0, background: 'rgba(232,73,29,.08)', color: 'var(--orange)', display: 'grid', placeItems: 'center' }}>
              <Icon size={20} />
            </span>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 700, fontSize: 14 }}>{name}</div>
              <div style={{ fontSize: 12, color: 'var(--muted)' }}>{desc}</div>
            </div>
            <button onClick={openSendModal} className="g-text-link" style={{ flexShrink: 0 }}>
              Enviar dinero <ArrowRight size={14} />
            </button>
          </div>
        ))}
      </div>

      {txs.length > 0 && (
        <div className="g-card" style={{ padding: '6px 20px' }}>
          <div className="g-section-title" style={{ padding: '14px 0 0' }}>
            <h2>Pagos recientes</h2>
            <a className="g-text-link" href="/app/historial">Ver historial <ArrowRight size={14} /></a>
          </div>
          {txs.map((t, i) => (
            <div key={t.ref || i} style={{
              display: 'flex', justifyContent: 'space-between', alignItems: 'center',
              padding: '11px 0', borderTop: i > 0 ? '1px solid #f1f1f4' : 'none', fontSize: 13,
            }}>
              <span style={{ color: 'var(--muted)' }}>
                {t.created_at ? new Date(t.created_at).toLocaleDateString('es', { day: 'numeric', month: 'short' }) : ''} · {t.recipient_name || t.ref}
              </span>
              <b>${parseFloat(t.amount_usd || 0).toFixed(2)}</b>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
